import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { ApiLogger } from "../../utils/apiLogger";

export const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    timeout: 300000,
    headers: {
        // Authorization: `Bearer ${UserToken.getInstance().getToken()}`,
        'Content-Type': 'application/json'
    }
});

// Request interceptor for auth and error tracking setup
api.interceptors.request.use((config: AxiosRequestConfig) => {
    // Add auth token
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${localStorage.getItem('apontamento.jwt')}`;
    
    // Add request timestamp for duration calculation in case of errors
    (config as any).metadata = { startTime: Date.now() };
    
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Response interceptor for error logging only
api.interceptors.response.use((response: AxiosResponse) => {
    // Success - no logging needed
    return response;
}, (error: AxiosError) => {
    const config = error.config as any;
    const duration = config?.metadata ? Date.now() - config.metadata.startTime : 0;
    const userInfo = getUserInfo();
    
    // Log error
    ApiLogger.logError({
        method: config?.method?.toUpperCase() || 'GET',
        url: config ? `${config.baseURL}${config.url}` : 'Unknown URL',
        params: config?.params,
        data: config?.data,
        duration,
        userId: userInfo?.idUsuario,
        userName: userInfo?.userName
    }, error);
    
    // Handle 401 errors
    if (error?.response?.status === 401) {
        window.location.href = '/';
    }
    
    return Promise.reject(error);
});

// Helper function to get user info from localStorage
function getUserInfo() {
    try {
        const userString = localStorage.getItem('user');
        return userString ? JSON.parse(userString) : null;
    } catch {
        return null;
    }
}